import { DebtAssetCategoryId } from 'interfaces/meta'

const mapToNew = {
  savings: 'asset_savings' as const,
  cd: 'asset_cd' as const,
  investment: 'asset_investment' as const,
  asset_other: 'asset_other' as const,
  home: 'asset_home' as const,
  asset_auto: 'asset_auto' as const,

  creditcard: 'debt_creditcard' as const,
  debt_other: 'debt_other' as const,
  debt_auto: 'debt_auto' as const,
  mortgage: 'debt_mortgage' as const,
  home_equity: 'debt_home_equity' as const,
  student: 'debt_student' as const,
}

type MapType = typeof mapToNew
export type NewCategories = MapType[keyof MapType]

const categories = Object.keys(mapToNew) as (keyof MapType)[]

const mapToOld = categories.reduce((acc, oldCategory) => {
  return {
    ...acc,
    [mapToNew[oldCategory]]: oldCategory,
  }
}, {} as Record<NewCategories, DebtAssetCategoryId>)

export const getOldCategory = (newCategory: NewCategories): DebtAssetCategoryId => {
  return mapToOld[newCategory]
}

export const getNewCategory = (oldCategory: DebtAssetCategoryId): NewCategories => {
  return mapToNew[oldCategory]
}
